import StepChartBar from "./step_chart_bar"

$(document).on 'turbolinks:load', ->
  div_chart      = $('#flot-placeholder')
  steps_response = div_chart.data 'steps-response'

  new StepChartBar(div_chart, steps_response).draw_chart() if steps_response != undefined